/*
  Change Frequently bought together widget position for product page
  original position: below add to cart form
  changed position: below main product image.
  implemented: layout/theme.liquid,
  For mobile widget will be displayed on the default position (adyacent/next element of product form).
  For desktop it will displayed below collapsible tabs.
*/
document.addEventListener("DOMContentLoaded", function () {
  
    function whenAvailable(DOM_element, callback, number_of_trys) {
      number_of_trys += 1;
      const appEl = document.querySelector(DOM_element)
      const interval = 1000; 
    
      console.log( number_of_trys)
      const int = window.setTimeout(function() {
          if (appEl) {
              callback(appEl);
              clearInterval(int)
          } else {
             number_of_trys <= 10 ? whenAvailable(DOM_element, callback, number_of_trys) : console.log("Reached limit for number_of_trys", number_of_trys);
          }
      }, interval);
    }

    whenAvailable(".upsells__title", function(el) {
       //console.log("FBT widget loaded", el.parentNode) 

      // Removed Hardcoded template and added generic selector to find app node
      //  const default_template = document.querySelector("[data-js-app='ATUNEdGh2WnYyMUQ3b__upselly_star_rating_TQYiHC']")
      //  const clear_stix_tempalte = document.querySelector("[data-js-app='ATlNhNUNraklPWG5wO__upselly_star_rating_TQYiHC']")
      //  const app_node =  default_template || clear_stix_tempalte

      const app_node = document.querySelector("[data-js-app*='upselly_star_rating']");

        if(!app_node || !el){
          return console.log('Cant find elements for Upselly APP')
        }

      
       const isDesktop = window.innerWidth >= 768
       //console.log("window width", window.innerWidth, isDesktop)
      
       const desktop_container = document.querySelector('[data-js-upselly-desktop]')
       const mobile_container = document.querySelector('[data-js-upselly-mobile]')
       isDesktop ? desktop_container?.appendChild(app_node) : mobile_container?.appendChild(app_node) ;

    //    if(!container){
    //     return console.log("Cant find container to append uppselly")
    //    }
    //    container.appendChild(app_node)

 
       app_node.classList.add("fade-in");
      
      
     },0);
  
})